module.exports = __webpack_public_path__ + "static/media/three-point-dice.2f3158ef.svg";